import {
  Grid,
  Card,
  TextField,
  Divider,
  Button,
  MenuItem,
  minHeight,
} from "@pankod/refine-mui";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";

function CardTreatment({
  last = true,
  treatment,
  setTreatment,
  setPrice,
  setChildrenPrice,
  addNew,
  removeCard,
  otherTreatmentsSet,
}) {
  const allOptions = [
    { label: "Nessuno", value: "" },
    { label: "Con colazione", value: "BB" },
    { label: "Mezza pensione", value: "HB" },
    { label: "Pensione completa", value: "FB" },
  ];
  const options = allOptions.filter(
    (item) => !otherTreatmentsSet.map((item) => item.name).includes(item.value)
  );
  //console.log(options, treatment.treatment);

  return (
    <Grid item xs={12} md={12} sx={{ height: "100%" }}>
      <Card
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Grid container sx={{ flex: 1, p: 2 }} spacing={2}>
          <Grid item xs={6} md={6} sx={{ height: "100%" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              variant={"outlined"}
              fullWidth
              select
              label="trattamento"
              value={treatment.name}
              onChange={(e) => {
                setTreatment(e.target.value);
              }}
              disabled={treatment.disabled}
            >
              {options.map((option, index) => (
                <MenuItem key={index} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6} md={3} sx={{ height: "100%" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              variant={"outlined"}
              fullWidth
              label="supplemento per persona"
              type={"number"}
              value={treatment.pricePerPerson}
              onChange={(e) => {
                setPrice(e.target.value);
              }}
              disabled={treatment.disabled}
            />
          </Grid>
          <Grid item xs={6} md={3} sx={{ height: "100%" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              variant={"outlined"}
              fullWidth
              label="supplemento per bambino"
              type={"number"}
              defaultValue={0}
              value={treatment.pricePerChild}
              onChange={(e) => {
                setChildrenPrice(e.target.value);
              }}
              disabled={treatment.disabled}
            />
          </Grid>
        </Grid>
        {!treatment.disabled || last ? (
          <>
            <Divider orientation="vertical" flexItem />
            <Button
              variant="contained"
              sx={{
                width: 30,
                alignSelf: "normal",
                alignItems: "center",
                bgcolor: "info.main",
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
              }}
              onClick={() => {
                last ? addNew() : removeCard();
              }}
            >
              {last ? (
                <AddCircleOutlineOutlinedIcon />
              ) : (
                <RemoveCircleOutlineOutlinedIcon />
              )}
            </Button>
          </>
        ) : (
          <></>
        )}
      </Card>
    </Grid>
  );
}

export default CardTreatment;
